"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _MenuItem = _interopRequireDefault(require("../MenuItem"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var Option = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Option, _Component);

  var _super = _createSuper(Option);

  function Option() {
    var _this;

    (0, _classCallCheck2.default)(this, Option);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleClick", function (event) {
      _this.props.onSelect(_this.props.option, event);
    });
    return _this;
  }

  (0, _createClass2.default)(Option, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          children = _this$props.children,
          isFocused = _this$props.isFocused;
      return /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
        id: "".concat(id, "-menu-item"),
        selected: isFocused,
        onClick: this.handleClick
      }, children);
    }
  }]);
  return Option;
}(_react.Component);

exports.default = Option;
(0, _defineProperty2.default)(Option, "propTypes", {
  /**
   * The html id
   */
  id: _propTypes.default.string,

  /**
   * The contents of the MenuOption
   */
  children: _propTypes.default.node,

  /**
   * Action taken when the component is focused on.
   */
  isFocused: _propTypes.default.bool,

  /**
   * Callback when a menu option is selected.
   *
   * Signature: `function(option: object, event: object) => void`
   */
  onSelect: _propTypes.default.func,

  /**
   * The option selected by the component
   */
  option: _propTypes.default.object
});